<template>
  <div>
    <div class="content">
      <Titulo
        class="mb-4"
        title="Novo Plano"
        description="Aqui vai uma explicação sobre esta página, o que ela faz, por exemplo."
      />
      <ListaCadastrosPlano
        :list="list"
        @remover="removerItem"
        @editar="editarItem"
      />
      <Botao
        :title="'INCLUIR NOVA VIDA'"
        :link="`/produto/cdl-saude-plano/planos?tipoCadastro=${
          list.length === 0 ? 'titular' : 'dependente'
        }`"
        :nameClass="'btn btn-success'"
        >INCLUIR {{ list.length === 0 ? "TITULAR" : "DEPENDENTE" }}</Botao
      >
      <div v-if="totalMensalidade" class="preco-total mt-5">
        <div class="preco-total-value text-primary">
          {{ totalMensalidade | currency }}
        </div>
        <div class="preco-total-label">por mês</div>
      </div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            link="/produto/cdl-saude-plano/listavidas"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
        <div class="col-md-4 col-lg-2">
          <Botao
            title="Próximo"
            link="/produto/cdl-saude-plano/finalizar-cadastro"
            nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
            >PRÓXIMO</Botao
          >
        </div>
      </div>
    </div>
    <div class="py-5"></div>
  </div>
</template>

<script>
import ListaCadastrosPlano from "@/components/vidas/ListaCadastrosPlano";
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
export default {
  name: "ListaVidas",
  components: { ListaCadastrosPlano, Titulo, Botao },
  data() {
    return {
      disable: true,
      produto: {
        nome: "CDL Saúde",
        id: "CDL Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Novo Plano",
          id: "movimentacao_vidas",
        },
      ],
      values: {},
      atualizar: 0,
      list: [],
      registros: [],
      schema: [
        {
          type: "radio",
          name: "tipo_plano",
          options: { titular: "Titular", dependente: "Dependente" },
          validation: "required",
        },
        {
          type: "text",
          name: "cpf",
          label: "CPF",
          validation: "required",
        },
        {
          type: "text",
          name: "nome",
          label: "Nome",
          validation: "required",
        },
        {
          type: "date",
          name: "data_nascimento",
          label: "Data de Nascimento",
          validation: "required",
        },
        {
          type: "email",
          name: "email",
          label: "Email",
          validation: "required|email",
        },
        {
          type: "text",
          name: "telefone",
          label: "Telefone",
          validation: "required",
          ":mask": "['(##) #####-####']",
        },
        {
          type: "submit",
          name: "Salvar",
        },
      ],
      totalMensalidade: 0,
    };
  },
  mounted() {
    this.getRegistros();
    if (this.registros.length == 0) {
      this.$router.push({ name: "planos", query: { tipoCadastro: "titular" } });
    }
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return valor ? formatter.format(valor) : "-";
    },
  },
  methods: {
    salvar() {
      if (this.atualizar) {
        this.registros[this.atualizar] = this.values;
      } else {
        this.registros.push(this.values);
      }
      const parsed = JSON.stringify(this.registros);
      localStorage.setItem("cdlsaude_cadastro", parsed);
      this.getRegistros();
      this.$formulate.reset("cadastro");
      this.atualizar = 0;
    },
    getRegistros() {
      if (localStorage.getItem("cdlsaude_cadastro")) {
        try {
          this.registros = JSON.parse(
            localStorage.getItem("cdlsaude_cadastro")
          );
          this.list = [];
          this.totalMensalidade = 0;
          this.registros.forEach((e, k) => {
            if (e.nome) {
              var totalOpcional = 0;
              e.descOpcionais.forEach((opcional) => {
                totalOpcional += opcional.opcional.price;
              });

              this.list.push({
                info: {
                  nome: {
                    label: e.tipoCadastro,
                    value: e.nome,
                  },
                  plano: {
                    label: "Plano",
                    value:
                      e.plano.operadora +
                      ", " +
                      e.plano.assistencia +
                      " (" +
                      e.plano.acomodacao +
                      ")",
                  },
                  preco: {
                    label: "por mês",
                    value: e.plano.valor + totalOpcional ?? 0,
                  },
                },
                actions: [
                  {
                    label: "Editar",
                    icon: "edit",
                    link: "",
                    disabled: false,
                    id: k,
                    action: "editar",
                  },
                  {
                    label: "Remover",
                    icon: "delete_forever",
                    link: "",
                    disabled: false,
                    id: k,
                    action: "remover",
                  },
                ],
              });
              this.totalMensalidade += e.plano.valor + totalOpcional;
            }
          });
          localStorage.setItem("totalMensalidade", this.totalMensalidade);
        } catch (e) {
          localStorage.removeItem("cdlsaude_cadastro");
        }
      }
    },
    removerItem(id) {
      this.$delete(this.registros, id);
      const parsed = JSON.stringify(this.registros);
      localStorage.setItem("cdlsaude_cadastro", parsed);
      this.getRegistros();
    },
    editarItem(id) {
      this.registros.forEach((data, index) => {
        if (index == id) {
          this.$router.push({
            name: "planos",
            query: { id: id, tipoCadastro: data.tipoCadastro },
          });
        }
      });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
.preco-total-label {
  font-weight: 300;
  font-size: 1rem;
  margin-bottom: 10px;
}
.preco-total-value {
  font-weight: bold;
  font-size: 1.4rem;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
